import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './index.scss';

const Container = ({ children, extendClass }) => (
    <div className={classNames({ [styles.container]: true, [extendClass]: extendClass })}>
        {children}
    </div>
);

Container.propTypes = {
    extendClass: PropTypes.string,
};

export default Container;
